import { useCallback } from 'react'
import { usePermissions } from '~/entities/viewer'
import { Promocode } from '~/shared/api/promocodes'
import { AsyncGrid, FetchRowsFn } from '~/shared/ui/AsyncGrid'
import { Button } from '~/shared/ui/Buttons'
import { PlusIcon } from '~/shared/ui/Icons'
import { columns } from './columns'
import { GridRow } from './types'

export const ListPromotion = () => {
  const { canPromocodesUpdate } = usePermissions()

  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize, filters = [], sort) => {
      let builder = Promocode.limit(pageSize)

      sort
        ? (builder = builder.orderBy(sort))
        : (builder = builder.orderBy('-createdAt'))

      filters.forEach(({ key, value }) => {
        if (key === 'regions') {
          builder = builder.option('filter[regions][id]', value)
        } else {
          builder = builder.where(key, value)
        }
      })

      const response = await builder.get(page)

      const data = response.getData()
      const rows = data.map((promocode: Promocode) => {
        return {
          ...promocode.getAttributes(),
          id: promocode.getApiId() as UniqueId,
          regions: promocode.getRegions().map((region) => region.getName()),
          carBrands: promocode
            .getCarBrands()
            .map((carBrand) => carBrand.getTitle()),
          carModels: promocode
            .getCarModels()
            .map((carModel) => carModel.getTitle()),
        }
      })

      /*
       * Coloquent не дает метода, чтобы получить объект meta,
       * поэтому в данном случае получаем оригинальный ответ и достаем мету из него
       * TODO: Реализовать лучший способ получения метаданных
       * */
      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const total = axiosResponse?.data?.meta?.page?.total || 0

      return {
        rows,
        total,
      }
    },
    [],
  )

  return (
    <AsyncGrid<GridRow>
      gridKey='promotions'
      columns={columns}
      smallTitle='Акции'
      fetchRows={fetchRows}
      headerExtra={
        <Button
          startDecorator={<PlusIcon />}
          to='new'
          show={canPromocodesUpdate}
        >
          Добавить
        </Button>
      }
    />
  )
}
